import classnames from 'classnames'
import { RefObject, useRef } from 'react'

import { useBatchedAnalyticsCaptureForCategoryCard } from '@src/quince-site-common/src/hooks/useBatchedAnalyticsCaptureForCatergoryCard'
import useIsVisible from '@src/quince-site-common/src/hooks/useIsVisible'

import { Image, ImageProps } from '../image'
import Link from '../link'

import styles from './categoryGridItem.module.scss'

export interface CategoryGridItemProps {
  imageProps: ImageProps
  title: string
  className?: string
  titleClassName?: string
  href?: string
  onClick?: () => void
  tracker?: string
  selectorKey?: string
  hasScrollToHash?: boolean
  position?: number
  categoryViewTracker?: string
  children?: React.ReactNode
}

export const CategoryGridItem = ({ className = '', ...props }: CategoryGridItemProps) => {
  const classes = classnames(styles.categoryItem, className, 'd-block')
  const WrapperComponent = props.hasScrollToHash ? (_prop: any) => <div {..._prop} /> : Link
  const wrapperRef: RefObject<HTMLDivElement> = useRef(null)
  const { isVisible } = useIsVisible(wrapperRef)

  useBatchedAnalyticsCaptureForCategoryCard({
    wrapperRef,
    isVisible,
    tracker: props.categoryViewTracker,
    title: props.title,
    position: props.position,
  })
  return (
    <WrapperComponent
      className={classes}
      href={props.href}
      onClick={props.onClick}
      ref={wrapperRef}
      trackConfig={
        props.tracker
          ? {
              trackInternal: true,
              trackGA: true,
              action: 'product_category_click',
              category: 'navigation',
              value: props.href,
              label: props.tracker,
              context: {
                position: props.position,
              },
            }
          : undefined
      }
      selectorKey={props.selectorKey}
    >
      {props.children || (
        <>
          <div className={styles.headingWrapper}>
            <h5 className={classnames(styles.heading, props.titleClassName, 'body2_grosa')}>{props.title}</h5>
          </div>
          <Image
            alt={props.imageProps.alt}
            {...props.imageProps}
            className={classnames(styles.image, props.imageProps.className)}
            loading={'lazy'}
          />
        </>
      )}
    </WrapperComponent>
  )
}

export default CategoryGridItem
